import { s } from "../lib/constants";

export default function ProgressBar({ progress }) {
  return (
    <div style={s.progressTrack}>
      <div style={{ ...s.progressFill, width: `${progress}%` }} />
    </div>
  );
}
